import React from "react";
import {VisionStatementInterface, VisionStatementStatus} from "../interfaces";
import CustomButton from "../../../components/CustomButton";
import PlainBadge from "../../../components/Badges/PlainBadge";
import iconArrowRight from "url:shared-assets/icons/black/arrow-right.svg";
import iconClock from "url:shared-assets/icons/clock.svg";
import {useNavigate} from "react-router";
import {useTranslation} from "react-i18next";
import {getLanguage} from "../../../lang/helpers";
import {renderOnTrack2} from "../helpers";


interface Props {
  visionStatement: VisionStatementInterface;
  nr: number;
  mainButtons?: number;
  answerOptions?: number;
}

const VisionStatementSummary = (props: Props)=> {
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(); // i18n translation hook
  const lang = getLanguage(i18n.language);

  const renderBadge = () => {
    if (props.visionStatement.status === VisionStatementStatus.Saved) {
      return (
        <PlainBadge text={lang === "sv" ? "Utkast" : "Draft"} color="gray" size="small"/>
      )
    } else if (props.visionStatement.progress === 100) {
      return (
        <PlainBadge text={lang === "sv" ? "Klar" : "Completed"} color="green" size="small"/>
      )
    } else if (props.visionStatement.status === VisionStatementStatus.Created && props.visionStatement.attention) {
      return renderOnTrack2(props.visionStatement.attention, lang);
    }
    return null;
  }

  let cls = "bg-indigo-900 mt-4 p-4 rounded-md border-indigo-800 border-1";
  if (props.visionStatement.status === 2) {
    cls += " hover:bg-indigo-800 cursor-pointer";
  }

  const clickVs = () => {
    if (props.visionStatement.status === 2) {
      navigate("/dev-plan/long-term-goal/" + props.visionStatement.id)
    }
  }

  return (
    <div className={cls}
         key={"vs_" + props.visionStatement.id} onClick={() => clickVs()}>
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-y-2">
        <div className="flex flex-col md:flex-row md:justify-between gap-x-2 items-start md:items-center">
          <div className="text-gray-100 z-title1">
            {props.visionStatement.title.length > 0 ? props.visionStatement.title :
              lang === "sv" ? "[Ingen titel än]" : "[No title yet]"}
          </div>
            {renderBadge()}
        </div>
        {
          props.visionStatement.deadline &&
            <div>
              <span className="z-title3 text-gray-100">
                {t("due-date")}:&nbsp;
              </span>
                <span className="text-sm text-gray-400">{props.visionStatement.deadline.substring(0, 10)}</span>
            </div>
        }
      </div>

      {
        (props.visionStatement.status === VisionStatementStatus.Created) &&
          <div>
            <div className="flex justify-between mt-2">
                <div className="flex gap-x-1 items-center">
                    <img src={iconClock} alt="time" className="h-4 w-4"/>
                    <div className="z-title3 text-gray-100!">{lang === "sv" ? "Tidsplan" : "Timeline"}</div>
                </div>
                <div className="z-body2 text-gray-400!">{props.visionStatement.timeProgress?.toFixed(0)}%</div>
            </div>
            <div className="mt-1 h-2 rounded-full bg-indigo-700 w-full">
              <div className="h-2 rounded-full bg-primary-500"
                   style={{width: props.visionStatement.timeProgress + "%"}}></div>
            </div>

            <div className="mt-2">
              <span
                  className="z-title3 text-gray-100">{lang === "sv" ? "Delmål" : "Sub-goals"}:&nbsp;
              </span>
                  <span className="z-body2 text-gray-400!">
                {props.visionStatement.goals}
              </span>
                  <span className="mx-2 z-body2 text-gray-100!">|</span>
                  <span
                      className="z-title3 text-gray-100">{lang === "sv" ? "Aktiviteter" : "Activities"}:&nbsp;
              </span>
                  <span className="z-body2 text-gray-400!">
                {props.visionStatement.activities}
              </span>
                  <span className="mx-2 z-body2 text-gray-100!">|</span>
                  <span
                      className="z-title3 text-gray-100">{lang === "sv" ? "Beteenden" : "Behaviours"}:&nbsp;
              </span>
                  <span className="z-body2 text-gray-400!">
                {props.visionStatement.behaviors}
              </span>
            </div>
          </div>
      }

      {
        (props.visionStatement.status === VisionStatementStatus.Saved) &&
          <div className="mt-4 flex justify-end">
              <CustomButton buttonType={(props.mainButtons && props.mainButtons > 1) ? "outlineWhiteBase" : "blueBase"}
                            style={{width: "unset"}}
                            rightIcon={<img src={iconArrowRight} alt="right" className="h-4 w-4"/>}
                            onClick={() => navigate("/dev-plan/long-term-goal/" + props.visionStatement.id)}>
                {t("create")} {t("vision_statement")}
              </CustomButton>
          </div>
      }
    </div>
  )
}

export default VisionStatementSummary;